import { render, staticRenderFns } from "./list_edit.vue?vue&type=template&id=772b49ab&scoped=true&"
import script from "./list_edit.vue?vue&type=script&lang=js&"
export * from "./list_edit.vue?vue&type=script&lang=js&"
import style0 from "./list_edit.vue?vue&type=style&index=0&id=772b49ab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772b49ab",
  null
  
)

export default component.exports